import { isMacOS } from "./ua-utils";
import { Keyboard } from "../enums";

/**
 * Checks whether cmd accelerator is being applied to keyboard event
 * this is useful to determine shortcuts with cmd
 **/
function cmdKey(ev: KeyboardEvent | MouseEvent): boolean {
    return isMacOS() ? ev.metaKey : ev.ctrlKey;
}

function ctrlOrWinKey(ev: KeyboardEvent): boolean {
    return isMacOS() ? ev.ctrlKey : ev.metaKey;
}

/**
 * Checks whether cmd key itself is pressed
 * this is useful to understand if cmd key is
 * the key that causes this event to be dispatched
 */
function isCmdPressed(ev: KeyboardEvent): boolean {
    return ev.key === (isMacOS() ? Keyboard.Key.Meta : Keyboard.Key.Ctrl);
}

/**
 * Checks whether shift key itself is pressed
 * this is useful to understand if cmd key is
 * the key that causes this event to be dispatched
 */
function isShiftPressed(ev: KeyboardEvent) {
    return ev.key === Keyboard.Key.Shift;
}

/**
 * Returns whether a modifier key is used in the event
 */
function modifierKeysUsed(ev: KeyboardEvent) {
    return ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey;
}

function onlyAltKeyPressed(ev: KeyboardEvent) {
    return !(ev.shiftKey || ev.ctrlKey || ev.metaKey) && ev.altKey;
}

export {
    cmdKey,
    ctrlOrWinKey,
    isCmdPressed,
    isShiftPressed,
    modifierKeysUsed,
    onlyAltKeyPressed
};
